import { ICycleFactory } from '../../entities/cycle/Cycle'
import { parseIsoDateTime } from '../../utils/parse-date'
import castListItems from '../castListItems'
import { IOrderResponse, transformOrder } from '../order/OrderTransformer'

export interface ICycleResponse {
    cycle_info: {
        acceptance_deadline: string | null // "2026-04-07T09:30:00+03:00"
        cycle_id: number
        code: string
        name: string
        order_from: string // "2025-04-07T08:00:00+03:00"
        order_to: string // "2026-04-07T08:00:00+03:00"
        days_before_1: number
        days_before_2: number
        delivery_from: string // "2026-04-07T08:00:00+03:00"
        delivery_to: string // "2026-04-07T14:00:00+03:00"
        delivery_after_1: number
        delivery_after_2: number
        pickup_from: string // "2026-04-07T08:00:00+03:00"
        pickup_to: string // "2026-04-07T14:00:00+03:00"
        pickup_x: number
        number_of_orders: number
        number_orders_labeled: number
        number_products: number
        number_products_ready: number
        number_open_orders: number
        number_products_labeled: number
        total_number_open_orders: number
        total_number_products: number
        total_number_products_labeled: number
    }
    orders: IOrderResponse[]
}

export const transformCycle = (cycle: ICycleResponse): ICycleFactory => {
    return {
        code: cycle.cycle_info.code,
        name: cycle.cycle_info.name,

        numberOfOrders: cycle.cycle_info.number_of_orders,
        numberOfOrdersLabeled: cycle.cycle_info.number_orders_labeled,
        numberOfOpenOrders: cycle.cycle_info.number_open_orders,
        totalNumberOfOpenOrders: cycle.cycle_info.total_number_open_orders,
        numberOfProducts: cycle.cycle_info.number_products,
        numberOfProductsLabeled: cycle.cycle_info.number_products_labeled,
        numberOfProductsReady: cycle.cycle_info.number_products_ready,

        pickupFrom: parseIsoDateTime(cycle.cycle_info.pickup_from),
        pickupTo: parseIsoDateTime(cycle.cycle_info.pickup_to),

        pickupX: cycle.cycle_info.pickup_x || 120,

        acceptanceDeadline: cycle.cycle_info.acceptance_deadline
            ? parseIsoDateTime(cycle.cycle_info.acceptance_deadline)
            : null,

        orders: castListItems(cycle.orders, transformOrder),

        totalNumberProducts: cycle.cycle_info.total_number_products,
        totalNumberProductsLabeled:
            cycle.cycle_info.total_number_products_labeled,
    }
}
